(function () {
  'use strict';

  // Fraction of the card width the nudge scrolls to peek the next image (35%).
  const PEEK_WIDTH_RATIO = 0.35;
  // Floor for the peek distance (px) so the hint stays visible on narrow cards (45 px)
  const MIN_PEEK_PX = 48;
  // Total duration (ms) of the out-and-back nudge animation.
  const NUDGE_DURATION_MS = 800;
  // Portion of the carousel that must be visible before the hint triggers (60%).
  const INTERSECTION_THRESHOLD = 0.6;
  // Matches the theme mobile breakpoint (theme.css hidden-phone).
  const MOBILE_MEDIA_QUERY = '(max-width: 740px)';

  // The variable that keep track if the nudge-hint animation was played.
  // Only plays on the first carousel that scrolls into view, and only once per page load.
  let hinted = false;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobileViewport() {
    return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
  }

  function runNudge(carousel) {
    if (hinted || prefersReducedMotion() || !isMobileViewport()) {
      return;
    }

    const track = carousel.querySelector('.product-item__carousel-track');

    if (!track) {
      return;
    }

    hinted = true;

    // Peek ~35% of the next image. We scroll the track (instead of using a CSS transform on it)
    // because the track is the scroll/clip boundary: a transform only shifts the box and leaves
    // the next slide clipped, while a real scroll reveals it.
    // Negative offset handles RTL (next image at left).
    const peek = Math.max(MIN_PEEK_PX, Math.round(track.clientWidth * PEEK_WIDTH_RATIO));
    const isRtl = window.getComputedStyle(track).direction === 'rtl';
    const direction = isRtl ? -1 : 1;
    const duration = NUDGE_DURATION_MS;

    // Temporarily disable mandatory snapping so direct scroll updates aren't
    // snapped back to the start mid-animation.
    const previousSnap = track.style.scrollSnapType;
    track.style.scrollSnapType = 'none';

    let startTime = null;

    function step(now) {
      if (startTime === null) {
        startTime = now;
      }

      const progress = (now - startTime) / duration;

      if (progress >= 1) {
        track.scrollLeft = 0;
        track.style.scrollSnapType = previousSnap;
        return;
      }

      // sin(0..PI) gives a continuous 0 -> 1 -> 0 curve: the track eases out to
      // the peek and glides back, always moving, with no pause at the peak.
      const eased = Math.sin(progress * Math.PI);
      track.scrollLeft = direction * peek * eased;

      window.requestAnimationFrame(step);
    }

    window.requestAnimationFrame(step);
  }

  function init() {
    if (!isMobileViewport() || prefersReducedMotion()) {
      return;
    }

    const carousels = document.querySelectorAll('boa-card-carousel');

    if (!carousels.length) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      runNudge(carousels[0]);
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || hinted) {
            return;
          }

          runNudge(entry.target);
          observer.disconnect();
        });
      },
      {
        root: null,
        threshold: INTERSECTION_THRESHOLD
      }
    );

    observer.observe(carousels[0]);
  }

  function start() {
    if (document.readyState === 'complete') {
      init();
    } else {
      window.addEventListener('load', init);
    }
  }

  start();
})();
